import Vue from "vue";
import App from "./App.vue";
import http from "./http";
import vuetify from "./plugins/vuetify";
import router from "./router";
import "./scss/style.scss";

Vue.config.productionTip = false;
Vue.prototype.$http = http;

window.Buffer = window.Buffer || require("buffer").Buffer;

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
